import { Button, Image } from "antd";
import React, { } from "react";
import Container from "../../General/Container/Container";
import { RedoOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
// import { MdPerson } from "react-icons/md";
import MinifiedServices from "../../../services/Minified.services"
import { setLoadingPersonasImage, setPersonasImage } from "../../../store/components/Minified.slice";
import personaPlacholder from "../../../images/personas/placeholder.png"


const PersonasImageReset = ({ data, forPrint }) => {
    const dispatch = useDispatch()
    const { personasParams } = useSelector((state) => state.minified)

    const onClickRetryPersonaImage = () => {
        dispatch(setLoadingPersonasImage(true))
        MinifiedServices.getPersonasImage(data, personasParams.itemId, true).then((respImage) => {
            dispatch(setLoadingPersonasImage(false))
            dispatch(setPersonasImage(respImage === "error" ? respImage : respImage.imageUrl || respImage.data))
        })
    }

    return <Container className="dcol align-center justify-center">
        {/* <MdPerson style={{ fontSize: "64px", color: "var(--bluegray-300" }} /> */}
        <Image src={personaPlacholder} preview={false} />
        {!forPrint && <span style={{ color: "var(--bluegray-300", fontSize: "14px", fontWeight: "400" }}>Unable to load Image</span>}
        <Button type="link"
            onClick={onClickRetryPersonaImage} icon={<RedoOutlined />}>
            Click to retry
        </Button>
    </Container>
}

export default PersonasImageReset